import { Flex, Text } from '@chakra-ui/react';

export type ReviewCardDateProps = {
  createdAt: string;
};

export const ReviewCardDate = ({ createdAt }: ReviewCardDateProps) => {
  return (
    <Flex>
      <Text size="sm">
        {createdAt}
      </Text>
    </Flex>
  );
};
